"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIcon = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("styled-components/native");
const react_native_svg_1 = require("react-native-svg");
const StepIcon_styles_1 = require("./StepIcon.styles");
const getStepIcon = (activeLabelColor, labelColor, completedLabelColor, isActiveStep, isCompletedStep) => {
    if (isActiveStep) {
        return (react_1.default.createElement(react_native_svg_1.Svg, { width: "42", height: "42", viewBox: "0 0 42 42" },
            react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, { transform: "translate(-24 -56) translate(24 56)" },
                        react_1.default.createElement(react_native_svg_1.Circle, { cx: "21", cy: "21", r: "20.5", stroke: activeLabelColor, strokeOpacity: ".4" }),
                        react_1.default.createElement(react_native_svg_1.G, { fill: activeLabelColor, transform: "translate(6 6.002)" },
                            react_1.default.createElement(react_native_svg_1.Rect, { width: "30", height: "30", rx: "15" })))))));
    }
    if (isCompletedStep) {
        return (react_1.default.createElement(react_native_svg_1.Svg, { width: "42", height: "42", viewBox: "0 0 42 42" },
            react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, { transform: "translate(-24 -122) translate(24 122)" },
                        react_1.default.createElement(react_native_svg_1.G, { fill: completedLabelColor, transform: "translate(6 6)" },
                            react_1.default.createElement(react_native_svg_1.Rect, { width: "30", height: "30", rx: "15" })),
                        react_1.default.createElement(react_native_svg_1.Circle, { cx: "21", cy: "21", r: "21" }),
                        react_1.default.createElement(react_native_svg_1.G, { stroke: "#FFF", strokeLinecap: "square" },
                            react_1.default.createElement(react_native_svg_1.G, null,
                                react_1.default.createElement(react_native_svg_1.Path, { d: "M0.689 5.191L3.94 8.442 12.068 0.315", transform: "translate(8.752 9) translate(5.835 8)" }))))))));
    }
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: "42", height: "42", viewBox: "0 0 42 42" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, null,
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, { fill: labelColor, opacity: ".503", transform: "translate(-24 -188) translate(24 188) translate(11 11)" },
                        react_1.default.createElement(react_native_svg_1.Rect, { width: "20", height: "20", rx: "10" })))))));
};
exports.StepIcon = ({ isActiveStep, isCompletedStep, label, activeLabelColor, activeLabelFontSize, borderStyle = 'solid', borderWidth = 2, completedProgressBarColor, completedLabelColor, labelFontFamily, labelColor, labelFontSize = 14, progressBarColor, isLastStep, stepIndex, onIconPress, }) => {
    const theme = native_1.useTheme();
    let styles;
    const rightBarStyle = {
        width: '100%',
        borderStyle,
        borderTopWidth: borderWidth,
    };
    const labelStyle = {
        textAlign: 'center',
        flexWrap: 'wrap',
        fontFamily: labelFontFamily,
        marginTop: 8,
    };
    if (isActiveStep) {
        styles = {
            labelText: {
                ...labelStyle,
                color: activeLabelColor || theme.bpCore.colors.primary[500],
                fontSize: activeLabelFontSize || labelFontSize,
            },
            rightBar: {
                ...rightBarStyle,
                borderTopColor: completedProgressBarColor || theme.bpCore.colors.primary[500],
            },
        };
    }
    else if (isCompletedStep) {
        styles = {
            labelText: {
                ...labelStyle,
                color: completedLabelColor || theme.bpCore.colors.primary[500],
                fontSize: labelFontSize,
            },
            rightBar: {
                ...rightBarStyle,
                borderTopColor: completedProgressBarColor || theme.bpCore.colors.primary[500],
            },
        };
    }
    else {
        styles = {
            labelText: {
                ...labelStyle,
                color: labelColor || theme.bpCore.colors.primary[200],
                fontSize: labelFontSize,
            },
            rightBar: {
                ...rightBarStyle,
                borderStyle: 'solid',
                borderTopColor: progressBarColor || theme.bpCore.colors.primary[500],
            },
        };
    }
    const onPressStepIcon = () => onIconPress(stepIndex);
    return (react_1.default.createElement(StepIcon_styles_1.StepContainer, { isLastStep: isLastStep },
        react_1.default.createElement(StepIcon_styles_1.StepIconWrapper, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { testID: "stepIcon", accessibilityLabel: `Step${stepIndex}`, accessibilityHint: `Mark Step${stepIndex} as complete`, accessibilityState: { selected: isActiveStep }, onPress: onPressStepIcon }, getStepIcon(activeLabelColor || theme.bpCore.colors.primary[500], labelColor || theme.bpCore.colors.primary[200], completedLabelColor || theme.bpCore.colors.primary[500], isActiveStep, isCompletedStep)),
            !isLastStep && (react_1.default.createElement(StepIcon_styles_1.LineWrapper, null,
                react_1.default.createElement(react_native_1.View, { style: styles.rightBar })))),
        react_1.default.createElement(react_native_1.Text, { style: styles.labelText }, label)));
};
